(() => {
  const formatMoney = (cents) => {
    if (cents == null) return ''

    const format = window.themeVariables?.settings?.moneyFormat
    if (format) {
      const amount = (cents / 100).toFixed(2)
      return format
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
        .replace(
          /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
          String(Math.round(cents / 100))
        )
        .replace(
          /\{\{\s*amount_with_apostrophe_separator\s*\}\}/g,
          amount.replace(/\B(?=(\d{3})+(?!\d))/g, "'")
        )
        .replace(/\{\{\s*amount\s*\}\}/g, amount)
    }

    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents)
    }

    return `$${(cents / 100).toFixed(2)}`
  }

  const initVariantPicker = (root) => {
    const badgesWrap = root.querySelector('.mt-product-hero__badges')
    const variantsScript = root.querySelector('[data-mt-product-hero-variants]')
    if (!badgesWrap || !variantsScript) return

    let variants
    try {
      variants = JSON.parse(variantsScript.textContent)
    } catch (e) {
      return
    }

    if (!Array.isArray(variants) || !variants.length) return

    const optionIndex = parseInt(badgesWrap.dataset.optionIndex, 10)
    if (Number.isNaN(optionIndex)) return

    const priceEl = root.querySelector('[data-product-price]')
    const comparePriceEl = root.querySelector('[data-product-compare-price]')
    const buyBtn = root.querySelector('[data-buy-link]')
    const viewBtn = root.querySelector('[data-view-link]')
    const productUrl = root.dataset.productUrl || ''

    const initialVariantId = parseInt(root.dataset.initialVariantId, 10)
    const initialVariant =
      variants.find((variant) => variant.id === initialVariantId) ||
      variants.find((variant) => variant.available) ||
      variants[0]

    let selectedOptions = initialVariant.options.slice()

    const findVariant = (options) =>
      variants.find((variant) => variant.options.every((opt, index) => opt === options[index]))

    const findVariantForOptionValue = (value) => {
      const options = selectedOptions.slice()
      options[optionIndex] = value

      const exactMatch = findVariant(options)
      if (exactMatch) return exactMatch

      return (
        variants.find((variant) => variant.options[optionIndex] === value && variant.available) ||
        variants.find((variant) => variant.options[optionIndex] === value)
      )
    }

    const updateUI = (variant) => {
      if (!variant) return

      selectedOptions = variant.options.slice()

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price)
      }

      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price)
          comparePriceEl.hidden = false
        } else {
          comparePriceEl.hidden = true
        }
      }

      if (buyBtn) {
        if (variant.available) {
          buyBtn.href = `/cart/${variant.id}:1?checkout`
          buyBtn.classList.remove('is-unavailable')
          buyBtn.removeAttribute('aria-disabled')
        } else {
          buyBtn.href = '#'
          buyBtn.classList.add('is-unavailable')
          buyBtn.setAttribute('aria-disabled', 'true')
        }
      }

      if (viewBtn && productUrl) {
        viewBtn.href = `${productUrl}?variant=${variant.id}`
      }

      badgesWrap.querySelectorAll('.mt-product-hero__badge').forEach((badge) => {
        const isSelected = badge.dataset.optionValue === variant.options[optionIndex]
        badge.classList.toggle('is-selected', isSelected)
        badge.setAttribute('aria-pressed', isSelected ? 'true' : 'false')
      })
    }

    badgesWrap.querySelectorAll('.mt-product-hero__badge').forEach((badge) => {
      badge.addEventListener('click', () => {
        const variant = findVariantForOptionValue(badge.dataset.optionValue)
        if (variant) updateUI(variant)
      })
    })

    updateUI(initialVariant)
  }

  const initPlayButton = (root) => {
    const playBtn = root.querySelector('.mt-product-hero__play-btn')
    if (!playBtn) return

    const video = root.querySelector('.mt-product-hero__video')
    if (!video) return

    playBtn.addEventListener('click', () => {
      video.muted = false
      const playPromise = video.play()

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {})
      }

      playBtn.classList.add('is-hidden')
    })
  }

  const initSection = (root) => {
    initVariantPicker(root)
    initPlayButton(root)
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.mt-product-hero[data-section-id]').forEach(initSection)
  })
})()
